import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../HttpClient";
import { validateBroadcastChannelPayload } from "../utils/inputSanitization";


export const createBroadcastChannel = createAsyncThunk("createBroadcastChannel", async (data) => {
    const validation = validateBroadcastChannelPayload(data);
    if (!validation.valid) {
        throw new Error(validation.message);
    }

    const sanitizedData = {
        ...data,
        name: validation.sanitized.name,
        description: validation.sanitized.description,
    };

    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/usermodels/notifications/channel`, sanitizedData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBroadcastChannels = createAsyncThunk("getBroadcastChannels", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/notifications/channel${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const createUserforBroadcastChannel = createAsyncThunk("createUserforBroadcastChannel", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/usermodels/notifications/userassetmap`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBroadcastChannelUsers = createAsyncThunk("getBroadcastChannelUsers", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/notifications/userassetmap${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const addNotificationTemplate = createAsyncThunk("addNotificationTemplate", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/usermodels/notifications/serv/template`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);
export const editNotificationTemplate = createAsyncThunk("editNotificationTemplate", async (data) => {
    try {
        const getAllData = await httpClient.put(`/internal-db/internal/db/usermodels/notifications/serv/template`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const getNotificationTemplate = createAsyncThunk("getNotificationTemplate", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/notifications/serv/template${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const addEvent = createAsyncThunk("addEvent", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/alert_api/event`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getEvents = createAsyncThunk("getEvents", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/alert_api/event${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const SignUpStatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            SignUpStatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

const NotificationSlice = createSlice({
    name: "NotificationSlice",
    initialState: {
        isAuthenticated: localStorage.getItem("token") ? true : false,
        signUpLoading: false,
        error: null,
        signUpResonse: "",
        loginLoading: false,
        loginResponse: "",
        loginStatusCode: "",
        user: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createBroadcastChannel.pending, (state, action) => {
                state.signUpLoading = true;
            })
            .addCase(createBroadcastChannel.fulfilled, (state, action) => {
                state.signUpLoading = false;
                state.signUpResonse = action.payload.response;
            })
            .addCase(createBroadcastChannel.rejected, (state, action) => {
                state.signUpLoading = false;
                state.error = action.payload;
            });
    },
})

export default NotificationSlice.reducer;